
import React from "react";
import "./term.css";

function Terms() {
  return (
    <div className="login-container-main">
      <div className="main-content">
        <h3 className="mb-10">Acceptance of Terms</h3>
        <div className="">Welcome to Get Sorted</div>
      </div>
    </div>
  );
}

export default Terms;
